export enum FakePermissions {
  MANAGE_FILES = 'MANAGE_FILES',
  MANAGE_FORMS = 'MANAGE_FORMS',
  MANAGE_SURVEYS = 'MANAGE_SURVEYS',
  MANAGE_WIDGETS = 'MANAGE_WIDGETS',
}

export enum UserPermissions {
  // CUSTOM
  CREATE_REGULAR_GROUP_CHAT = 'CREATE_REGULAR_GROUP_CHAT',
  CREATE_POLLS = 'CREATE_POLLS',
  CREATE_POSTS = 'CREATE_POSTS',
  CREATE_COMMENT = 'CREATE_COMMENT',
  CREATE_ACKNOWLEDGEMENTS = 'CREATE_ACKNOWLEDGEMENTS',
  ACCESS_ACKNOWLEDGEMENTS = 'ACCESS_ACKNOWLEDGEMENTS',
  RECEIVE_ACKNOWLEDGEMENTS = 'RECEIVE_ACKNOWLEDGEMENTS',
  INVITE_USERS = 'INVITE_USERS',
  CAN_SEGMENTATE = 'CAN_SEGMENTATE',
  SEND_PUSH_NOTIFICATION = 'SEND_PUSH_NOTIFICATION',
  FILL_FORM = 'FILL_FORM',
  FILL_SURVEY = 'FILL_SURVEY',
  // OLD MANAGEMENT
  MANAGE_POSTS = 'MANAGE_POSTS',
  MANAGE_MARKETPLACE_POSTS = 'MANAGE_MARKETPLACE_POSTS',
  MANAGE_USERS = 'MANAGE_USERS',
  MANAGE_CAPABILITIES = 'MANAGE_CAPABILITIES',
  MANAGE_SEGMENTATION = 'MANAGE_SEGMENTATION',
  MANAGE_ARTICLES = 'MANAGE_ARTICLES',
  MANAGE_VACATIONS = 'MANAGE_VACATIONS',
  MANAGE_PRODUCTS = 'MANAGE_PRODUCTS',
  MANAGE_TICKET_TOPICS = 'MANAGE_TICKET_TOPICS',
  MANAGE_INSTANCE = 'MANAGE_INSTANCE',
  MANAGE_ACKNOWLEDGEMENTS = 'MANAGE_ACKNOWLEDGEMENTS',
  MANAGE_COMMENTS = 'MANAGE_COMMENTS',
  MANAGE_REVIEWS = 'MANAGE_REVIEWS',
  // NEW MANAGEMENT
  CREATE_FILE = 'CREATE_FILE',
  EDIT_FILE = 'EDIT_FILE',
  DELETE_FILE = 'DELETE_FILE',
  CREATE_FORM = 'CREATE_FORM',
  EDIT_FORM = 'EDIT_FORM',
  DELETE_FORM = 'DELETE_FORM',
  CREATE_SURVEY = 'CREATE_SURVEY',
  EDIT_SURVEY = 'EDIT_SURVEY',
  DELETE_SURVEY = 'DELETE_SURVEY',
  CREATE_WIDGET = 'CREATE_WIDGET',
  EDIT_WIDGET = 'EDIT_WIDGET',
  DELETE_WIDGET = 'DELETE_WIDGET',
  CREATE_KNOWLEDGE_LIBRARIES = 'CREATE_KNOWLEDGE_LIBRARIES',
  EDIT_KNOWLEDGE_LIBRARIES = 'EDIT_KNOWLEDGE_LIBRARIES',
  DELETE_KNOWLEDGE_LIBRARIES = 'DELETE_KNOWLEDGE_LIBRARIES',
  CREATE_TRAININGS = 'CREATE_TRAININGS',
  EDIT_TRAININGS = 'EDIT_TRAININGS',
  DELETE_TRAININGS = 'DELETE_TRAININGS',
  CREATE_ONBOARDING = 'CREATE_ONBOARDING',
  EDIT_ONBOARDING = 'EDIT_ONBOARDING',
  DELETE_ONBOARDING = 'DELETE_ONBOARDING',
  CREATE_DOCUMENT = 'CREATE_DOCUMENT',
  EDIT_DOCUMENT = 'EDIT_DOCUMENT',
  DELETE_DOCUMENT = 'DELETE_DOCUMENT',
  // MODULES
  VIEW_WIDGET = 'VIEW_WIDGET',
  VIEW_SURVEY = 'VIEW_SURVEY',
  VIEW_FORM = 'VIEW_FORM',
  VIEW_FILE = 'VIEW_FILE',
  VIEW_POSTS = 'VIEW_POSTS',
  VIEW_GROUPS = 'VIEW_GROUPS',
  VIEW_POST_STATS = 'VIEW_POST_STATS',
  VIEW_ARTICLES = 'VIEW_ARTICLES',
  VIEW_REVIEWS = 'VIEW_REVIEWS',
  VIEW_REGULAR_CHATS = 'VIEW_REGULAR_CHATS',
  VIEW_TICKETS = 'VIEW_TICKETS',
  VIEW_ACKNOWLEDGMENTS_RANKING = 'VIEW_ACKNOWLEDGMENTS_RANKING',
  VIEW_TRAININGS = 'VIEW_TRAININGS',
  VIEW_PEOPLE = 'VIEW_PEOPLE',
  VIEW_ONBOARDING = 'VIEW_ONBOARDING',
  VIEW_BIRTHDAYS = 'VIEW_BIRTHDAYS',
  VIEW_ANNIVERSARIES = 'VIEW_ANNIVERSARIES',
  VIEW_DOCUMENT = 'VIEW_DOCUMENT',
  VIEW_KNOWLEDGE_LIBRARIES = 'VIEW_KNOWLEDGE_LIBRARIES',
  VIEW_MARKETPLACE = 'VIEW_MARKETPLACE',
  VIEW_ORGANIZATION_CHARTS = 'VIEW_ORGANIZATION_CHARTS',
  VIEW_VACATIONS = 'VIEW_VACATIONS',
  VIEW_EVENTS_NEMAK = 'VIEW_EVENTS_NEMAK',
  VIEW_ACKNOWLEDGMENTS_NEMAK = 'VIEW_ACKNOWLEDGMENTS_NEMAK',
  VIEW_WORKFLOWS = 'VIEW_WORKFLOWS',
}

export enum UserBackOfficePermissions {
  // OLD MANAGEMENT
  MANAGE_USERS = 'MANAGE_USERS',
  MANAGE_CAPABILITIES = 'MANAGE_CAPABILITIES',
  MANAGE_SEGMENTATION = 'MANAGE_SEGMENTATION',
  MANAGE_ARTICLES = 'MANAGE_ARTICLES',
  MANAGE_VACATIONS = 'MANAGE_VACATIONS',
  MANAGE_PRODUCTS = 'MANAGE_PRODUCTS',
  MANAGE_TICKET_TOPICS = 'MANAGE_TICKET_TOPICS',
  MANAGE_INSTANCE = 'MANAGE_INSTANCE',
  MANAGE_ACKNOWLEDGEMENTS = 'MANAGE_ACKNOWLEDGEMENTS',
  MANAGE_COMMENTS = 'MANAGE_COMMENTS',
  // NEW MANAGEMENT
  CREATE_FILE = 'CREATE_FILE',
  EDIT_FILE = 'EDIT_FILE',
  DELETE_FILE = 'DELETE_FILE',
  CREATE_FORM = 'CREATE_FORM',
  EDIT_FORM = 'EDIT_FORM',
  DELETE_FORM = 'DELETE_FORM',
  CREATE_SURVEY = 'CREATE_SURVEY',
  EDIT_SURVEY = 'EDIT_SURVEY',
  DELETE_SURVEY = 'DELETE_SURVEY',
  CREATE_WIDGET = 'CREATE_WIDGET',
  EDIT_WIDGET = 'EDIT_WIDGET',
  DELETE_WIDGET = 'DELETE_WIDGET',
  CREATE_KNOWLEDGE_LIBRARIES = 'CREATE_KNOWLEDGE_LIBRARIES',
  EDIT_KNOWLEDGE_LIBRARIES = 'EDIT_KNOWLEDGE_LIBRARIES',
  DELETE_KNOWLEDGE_LIBRARIES = 'DELETE_KNOWLEDGE_LIBRARIES',
  CREATE_TRAININGS = 'CREATE_TRAININGS',
  EDIT_TRAININGS = 'EDIT_TRAININGS',
  DELETE_TRAININGS = 'DELETE_TRAININGS',
  CREATE_ONBOARDING = 'CREATE_ONBOARDING',
  EDIT_ONBOARDING = 'EDIT_ONBOARDING',
  DELETE_ONBOARDING = 'DELETE_ONBOARDING',
  CREATE_DOCUMENT = 'CREATE_DOCUMENT',
  EDIT_DOCUMENT = 'EDIT_DOCUMENT',
  DELETE_DOCUMENT = 'DELETE_DOCUMENT',
}

export enum UserCapabilityNames {
  CREATE_POLLS = 'CREATE_POLLS',
  CREATE_POSTS = 'CREATE_POSTS',
  CREATE_FILE = 'CREATE_FILE',
  CREATE_WIDGET = 'CREATE_WIDGET',
  CREATE_SURVEY = 'CREATE_SURVEY',
  CREATE_FORM = 'CREATE_FORM',
  CREATE_ACKNOWLEDGEMENTS = 'CREATE_ACKNOWLEDGEMENTS',
  CREATE_TRAININGS = 'CREATE_TRAININGS',
  CREATE_ONBOARDING = 'CREATE_ONBOARDING',
  CREATE_DOCUMENT = 'CREATE_DOCUMENT',
  EDIT_SURVEY = 'EDIT_SURVEY',
  EDIT_FORM = 'EDIT_FORM',
  EDIT_WIDGET = 'EDIT_WIDGET',
  EDIT_FILE = 'EDIT_FILE',
  EDIT_TRAININGS = 'EDIT_TRAININGS',
  EDIT_ONBOARDING = 'EDIT_ONBOARDING',
  EDIT_DOCUMENT = 'EDIT_DOCUMENT',
  DELETE_SURVEY = 'DELETE_SURVEY',
  DELETE_FORM = 'DELETE_FORM',
  DELETE_WIDGET = 'DELETE_WIDGET',
  DELETE_FILE = 'DELETE_FILE',
  DELETE_TRAININGS = 'DELETE_TRAININGS',
  DELETE_ONBOARDING = 'DELETE_ONBOARDING',
  DELETE_DOCUMENT = 'DELETE_DOCUMENT',
  MANAGE_POSTS = 'MANAGE_POSTS',
  MANAGE_MARKETPLACE_POSTS = 'MANAGE_MARKETPLACE_POSTS',
  MANAGE_USERS = 'MANAGE_USERS',
  MANAGE_CAPABILITIES = 'MANAGE_CAPABILITIES',
  MANAGE_SEGMENTATION = 'MANAGE_SEGMENTATION',
  MANAGE_ARTICLES = 'MANAGE_ARTICLES',
  MANAGE_VACATIONS = 'MANAGE_VACATIONS',
  MANAGE_PRODUCTS = 'MANAGE_PRODUCTS',
  MANAGE_TICKET_TOPICS = 'MANAGE_TICKET_TOPICS',
  MANAGE_ACKNOWLEDGEMENTS = 'MANAGE_ACKNOWLEDGEMENTS',
  MANAGE_COMMENTS = 'MANAGE_COMMENTS',
  MANAGE_INSTANCE = 'MANAGE_INSTANCE',
  RECEIVE_ACKNOWLEDGEMENTS = 'RECEIVE_ACKNOWLEDGEMENTS',
  CAN_SEGMENTATE = 'CAN_SEGMENTATE',
  SEND_PUSH_NOTIFICATION = 'SEND_PUSH_NOTIFICATION',
  INVITE_USERS = 'INVITE_USERS',
  CREATE_API_KEY = 'CREATE_API_KEY',
  CREATE_REGULAR_GROUP_CHAT = 'CREATE_REGULAR_GROUP_CHAT',
  DUPLICATE_INSTANCE = 'DUPLICATE_INSTANCE',
  IGNORE_SEGMENTATION = 'IGNORE_SEGMENTATION',
}

export enum InstanceCapabilityNames {
  VIEW_FILE = 'VIEW_FILE',
  VIEW_POSTS = 'VIEW_POSTS',
  VIEW_ARTICLES = 'VIEW_ARTICLES',
  VIEW_REGULAR_CHATS = 'VIEW_REGULAR_CHATS',
  VIEW_TICKETS = 'VIEW_TICKETS',
  VIEW_ACKNOWLEDGMENTS_RANKING = 'VIEW_ACKNOWLEDGMENTS_RANKING',
  VIEW_TRAININGS = 'VIEW_TRAININGS',
  VIEW_PEOPLE = 'VIEW_PEOPLE',
  ACCESS_ACKNOWLEDGEMENTS = 'ACCESS_ACKNOWLEDGEMENTS',
  VIEW_SURVEY = 'VIEW_SURVEY',
  VIEW_FORM = 'VIEW_FORM',
  VIEW_WIDGET = 'VIEW_WIDGET',
  VIEW_ONBOARDING = 'VIEW_ONBOARDING',
  CREATE_COMMENT = 'CREATE_COMMENT',
  VIEW_DOCUMENT = 'VIEW_DOCUMENT',
  VIEW_BIRTHDAYS = 'VIEW_BIRTHDAYS',
  CAN_EXCHANGE = 'CAN_EXCHANGE',
}

export const USER_APP_PERMISSIONS = [
  UserPermissions.CREATE_POSTS,
  UserPermissions.CREATE_POLLS,
  UserPermissions.CAN_SEGMENTATE,
  UserPermissions.RECEIVE_ACKNOWLEDGEMENTS,
  UserPermissions.CREATE_ACKNOWLEDGEMENTS,
  UserPermissions.SEND_PUSH_NOTIFICATION,
  UserPermissions.INVITE_USERS,
];

export const ROUTE_PERMISSIONS = {
  FEED: [UserPermissions.VIEW_POSTS],
  GROUPS: [UserPermissions.VIEW_GROUPS],
  POST_INSIGHTS: [UserPermissions.VIEW_POST_STATS],
  NEWS: [UserPermissions.VIEW_ARTICLES],
  PROFILE: [],
  USER_FEED: [UserPermissions.VIEW_POSTS],
  USER_ACKNOWLEDGEMENTS: [UserPermissions.ACCESS_ACKNOWLEDGEMENTS],
  CHATS: [UserPermissions.VIEW_REGULAR_CHATS, UserPermissions.VIEW_TICKETS],
  TICKETS: [UserPermissions.VIEW_TICKETS],
  REGULAR_CHATS: [UserPermissions.VIEW_REGULAR_CHATS],
  NEW_ONE_TO_ONE: [UserPermissions.VIEW_REGULAR_CHATS],
  NEW_TICKET: [UserPermissions.VIEW_TICKETS],
  NEW_GROUP: [
    UserPermissions.VIEW_REGULAR_CHATS,
    UserPermissions.CREATE_REGULAR_GROUP_CHAT,
  ],
  FILES: [UserPermissions.VIEW_FILE],
  PEOPLE: [UserPermissions.VIEW_PEOPLE],
  PERFORMANCE: [UserPermissions.VIEW_REVIEWS],
  FORMS: [UserPermissions.VIEW_FORM],
  TRAININGS: [UserPermissions.VIEW_TRAININGS],
  SURVEYS: [UserPermissions.VIEW_SURVEY],
  KNOWLEDGE_LIBRARY: [UserPermissions.VIEW_KNOWLEDGE_LIBRARIES],
  ONBOARDING: [UserPermissions.VIEW_ONBOARDING],
  DOCUMENTS: [UserPermissions.VIEW_DOCUMENT],
  MARKETPLACE: [UserPermissions.VIEW_MARKETPLACE],
  WIDGETS: [UserPermissions.VIEW_WIDGET],
  ORG_CHART: [UserPermissions.VIEW_ORGANIZATION_CHARTS],
  VACATIONS: [UserPermissions.VIEW_VACATIONS],
  EVENTS_NEMAK: [UserPermissions.VIEW_EVENTS_NEMAK],
  RECOGNITIONS_NEMAK: [UserPermissions.VIEW_ACKNOWLEDGMENTS_NEMAK],
  WORKFLOWS: [UserPermissions.VIEW_WORKFLOWS],
};

export const hasAnyPermissions = (userPermissions: string[], requiredPermissions: string[]) =>
  !requiredPermissions
  || requiredPermissions.length === 0
  || requiredPermissions.some((requiredPermission) => userPermissions.includes(requiredPermission));

export const hasAllPermissions = (userPermissions: string[], requiredPermissions: string[]) =>
  !requiredPermissions
  || requiredPermissions.length === 0
  || requiredPermissions.every((requiredPermission) =>
    userPermissions.includes(requiredPermission));

const MINIMUM_REQUIRED_PERMISSIONS = [];

const ADMIN_MINIMUM_REQUIRED_PERMISSIONS = [
  UserPermissions.MANAGE_USERS,
  UserPermissions.MANAGE_CAPABILITIES,
  UserPermissions.MANAGE_SEGMENTATION,
  UserPermissions.MANAGE_ARTICLES,
  UserPermissions.MANAGE_PRODUCTS,
  UserPermissions.MANAGE_TICKET_TOPICS,
  UserPermissions.MANAGE_ACKNOWLEDGEMENTS,
  UserPermissions.MANAGE_INSTANCE,
  UserPermissions.CREATE_FILE,
  UserPermissions.EDIT_FILE,
  UserPermissions.DELETE_FILE,
  UserPermissions.CREATE_SURVEY,
  UserPermissions.EDIT_SURVEY,
  UserPermissions.DELETE_SURVEY,
  UserPermissions.CREATE_FORM,
  UserPermissions.EDIT_FORM,
  UserPermissions.DELETE_FORM,
  UserPermissions.CREATE_WIDGET,
  UserPermissions.EDIT_WIDGET,
  UserPermissions.DELETE_WIDGET,
  UserPermissions.CREATE_KNOWLEDGE_LIBRARIES,
  UserPermissions.EDIT_KNOWLEDGE_LIBRARIES,
  UserPermissions.DELETE_KNOWLEDGE_LIBRARIES,
  UserPermissions.CREATE_TRAININGS,
  UserPermissions.EDIT_TRAININGS,
  UserPermissions.DELETE_TRAININGS,
  UserPermissions.CREATE_ONBOARDING,
  UserPermissions.EDIT_ONBOARDING,
  UserPermissions.DELETE_ONBOARDING,
  UserPermissions.CREATE_DOCUMENT,
  UserPermissions.EDIT_DOCUMENT,
  UserPermissions.DELETE_DOCUMENT,
  UserPermissions.CREATE_KNOWLEDGE_LIBRARIES,
  UserPermissions.EDIT_KNOWLEDGE_LIBRARIES,
  UserPermissions.DELETE_KNOWLEDGE_LIBRARIES,
  UserPermissions.MANAGE_VACATIONS,
];

export const canLogin = (userPermissions: string[]) =>
  hasAnyPermissions(userPermissions, MINIMUM_REQUIRED_PERMISSIONS);

export const isAdmin = (userPermissions: string[]) =>
  hasAnyPermissions(userPermissions, ADMIN_MINIMUM_REQUIRED_PERMISSIONS);

const realToFakeMappings = {
  [FakePermissions.MANAGE_FILES]:
    [UserPermissions.EDIT_FILE, UserPermissions.DELETE_FILE, UserPermissions.CREATE_FILE],
  [FakePermissions.MANAGE_FORMS]:
    [UserPermissions.EDIT_FORM, UserPermissions.DELETE_FORM, UserPermissions.CREATE_FORM],
  [FakePermissions.MANAGE_SURVEYS]:
    [UserPermissions.EDIT_SURVEY, UserPermissions.DELETE_SURVEY, UserPermissions.CREATE_SURVEY],
  [FakePermissions.MANAGE_WIDGETS]:
    [UserPermissions.EDIT_WIDGET, UserPermissions.DELETE_WIDGET, UserPermissions.CREATE_WIDGET],
};

export type Permission = UserPermissions | FakePermissions;

export const realToFakePermissions = (permissions: Record<UserPermissions, boolean>) => {
  const newPermissions = { ...permissions };
  // iterate each mapping
  Object.entries(realToFakeMappings)
    .forEach(([fake, reals]: [FakePermissions, UserPermissions[]]) => {
      // if user permissions has all real permissions of the mapping, add the fake one
      if (reals.every((realPermission) => permissions[realPermission])) {
        newPermissions[fake] = true;
      }
    });

  return newPermissions;
};

export const fakeToRealPermissions = (permissions: Record<UserPermissions, boolean>) => {
  const newPermissions = { ...permissions };
  // iterate each mapping
  Object.entries(realToFakeMappings)
    .forEach(([fake, reals]: [FakePermissions, UserPermissions[]]) => {
      // replace it with the real ones based on the fake permission
      reals.forEach((real) => newPermissions[real] = !!newPermissions[fake]);

      // remove fake permission
      delete newPermissions[fake];
    });
  return newPermissions;
};

export const insertIf = (
  permissions: string[],
  requiredPermissions: string[],
  value: any,
): any[] =>
  ((hasAnyPermissions(permissions, requiredPermissions)) ? [value] : []);

export const guardFilter = (
  items: any[],
  permissions: string[],
): any[] => items.filter((item) =>
  hasAnyPermissions(permissions, item.requiredPermissions));

export const updatePermissions = (
  permissions: Record<UserPermissions, boolean>,
  capabilities: Record<UserCapabilityNames, boolean> | Record<InstanceCapabilityNames, boolean>,
): Record<UserPermissions, boolean> => {
  if (!permissions) return permissions;

  const newPermissions = { ...permissions };

  Object.keys(capabilities).forEach((capability) =>
    newPermissions[capability] = capabilities[capability]);

  return newPermissions;
};
